export class QSCMJournal {
  constructor() {
    this.fJournalChanged = false;
    this.fSubChartMasterList = null;
    this.fSubChartObjList = null;

    this.fSCM = null;
    this.fSCNodeList = null;
    this.fLayoutObjList = null;
  }

  InitJournal(scMgr) {
    this.fSCM = scMgr;
    this.fSubChartObjList = [];
    this.fLayoutObjList = [];
  }

  FindSubChartObj(subChart) {
    var n = this.fSubChartObjList.length;
    for (var i = 0; i < n; i++) {
      var sObj = this.fSubChartObjList[i];
      var srcObj = sObj.GetSourceObj();

      if (subChart == srcObj) return i;
    }

    return -1;
  }

  GetUpdateCode() {
    return null;
  }

  JournalChanged() {
    return this.fJournalChanged;
  }

  JournalSubChartChg(subChart) {
    var index = this.FindSubChartObj(subChart);
    if (index == -1) {
      this.fJournalChanged = true;
      var serialClone = subChart.SerialClone();
      this.fSubChartObjList.push(serialClone);
    }
  }

  FindLayoutObj(aLayout) {
    var scNodeRef1 = aLayout.GetSCNodeRef();
    //TODO: Index???
    var n = this.fLayoutObjList.length;
    for (var i = 0; i < n; i++) {
      var sObj = this.fLayoutObjList[i];
      var scNodeRef2 = sObj.GetSCNodeRef();
      if (scNodeRef1 == scNodeRef2) return i;
    }

    return -1;
  }

  JournalLayoutChg(aLayout) {
    var index = this.FindLayoutObj(aLayout);
    if (index == -1) {
      this.fJournalChanged = true;
      var layoutClone = aLayout.Clone();
      this.fLayoutObjList.push(layoutClone);
    }
  }

  JournalPaginationChg() {
    this.fManualPaginationDeltas = this.fSCM.SerializeBreaks();
    this.fJournalChanged = true;
  }

  SubChartListChanged(subChartList) {
    if (this.fSubChartMasterList == null) {
      this.fSubChartMasterList = subChartList.slice(0);
      this.fJournalChanged = true;
    }
  }

  SCNodeListChanged(scNodeList) {
    if (this.fSCNodeList == null) {
      this.fSCNodeList = scNodeList.slice(0);
      this.fJournalChanged = true;
    }
  }

  Restore() {
    //console.log("QSCMJournal:Restore:");
    if (this.fSubChartMasterList != null) this.fSCM.SetSubChartList(this.fSubChartMasterList);

    var n = this.fSubChartObjList.length;
    for (var i = 0; i < n; i++) {
      var serialObj = this.fSubChartObjList[i];
      serialObj.Restore();
    }

    if (this.fSCNodeList != null) {
      this.fSCM.SetSCNodeList([...this.fSCNodeList]);
    }

    if (this.fLayoutObjList != null) {
      var doc = this.fSCM.GetDoc();
      var lm = doc.GetLayoutMgr();
      lm.RestoreLayouts([...this.fLayoutObjList]);
    }

    if (this.fManualPaginationDeltas) {
      this.fSCM.RestoreBreaks(this.fManualPaginationDeltas);
    }
  }
}
